import React from "react";
import PropTypes from "prop-types";
import TechStafferBankerTimeLog from "./tech-staffer-banker-time-log/tech-staffer-banker-time-log";
import TechStafferDealTimeLog from "./tech-staffer-deal-time-log/tech-staffer-deal-time-log";

const DashboardTechStaffer = ({ techBankerTimeLogData, isAdmin, isStaffer, currSubDepartment }) => {
  const techMembers = techBankerTimeLogData?.TechMembers ?? [];
  const techProjects = techBankerTimeLogData?.TechProjects ?? [];
  const showDealTimeLog = isAdmin || isStaffer || techBankerTimeLogData === null || techBankerTimeLogData === undefined;

  let subTitle;
  if (currSubDepartment?.includes("NY")) {
    subTitle = "GIB/Technology NY";
  } else if (currSubDepartment?.includes("SF")) {
    subTitle = "GIB/Technology SF";
  } else {
    subTitle = "Technology";
  }

  return (
    <div>
      <TechStafferBankerTimeLog
        techMembers={techMembers}
        isStaffer={isStaffer}
        subTitle={subTitle}
      />
      {showDealTimeLog && (
        <div className="new-dashboard mt">
          <TechStafferDealTimeLog
            techProjects={techProjects}
            isStaffer={isStaffer}
            subTitle={subTitle}
          />
        </div>
      )}
    </div>
  );
};

DashboardTechStaffer.propTypes = {
  techBankerTimeLogData: PropTypes.shape({
    TechMembers: PropTypes.array,
    TechProjects: PropTypes.array,
  }),
  isAdmin: PropTypes.bool,
  isStaffer: PropTypes.bool,
  currSubDepartment: PropTypes.string,
};

export default DashboardTechStaffer;
